/**
 * @name                                    tools.ts
 * @description                             More tools !
*/


/* ---------------------------------------- PACK ----------------------------------------  */

    import * as types                       from './types';
    import { style }                        from './format';

/* ---------------------------------------- ---- ----------------------------------------  */


/* ---------------------------------------- CORE ----------------------------------------  */

    /**
     * Applies styles to a given message based on a pattern and optional values.
     *
     * @param {any} msg                     - The message to apply styles to.
     * @param {types.t_pattern} pattern   - The pattern to apply styles from.
     * @param {object} [values]             - Optional values to use for dynamic styles.
     * @return {string}                     The formatted message with applied styles.
    */
    export const apply
    = (msg: any, pattern: types.t_pattern, values?: {})
    : string =>
    {
        let result = '';

        for (let x = 0; x < pattern.length; x++)
        {
            const pat = pattern[x];

            for (let i = 0; i < pat.length; i++)
            {
                if(values && pat[i].gvalue)
                {
                    result += style((values as any)[pat[i].gvalue ? pat[i].gvalue : msg], pat[i].options);
                }
                else result += style(pat[i].value || msg, pat[i].options);
            }

            // add
            if(x < pattern.length - 1) result += '\n';
        }

        return result;
    };

    /**
     * Combines multiple messages with patterns and optional values into a single string.
     *
     * @param {Array<{ msg?: any, pattern?: any, values?: any }>} opt - An array of objects containing the message, pattern, and optional values.
     * @return {string}                     - The combined string with applied styles.
    */
    export const combine
    = (opt : { msg ?: any, pattern ?:any, values ?: any }[] )
    : string =>
    {
        let res = '';

        for (let i = 0; i < opt.length; i++)
        {
            res += apply(opt[i].msg, opt[i].pattern, opt[i].values);

            if(i < opt[i].pattern.length - 1) res += '\n';
        }

        return res;
    }

/* ---------------------------------------- ---- ----------------------------------------  */